// extracted by mini-css-extract-plugin
export default {"icon":"Services_icon__suIFs"};